/**
 * AWS Bedrock supported regions.
 *
 * @see https://docs.aws.amazon.com/general/latest/gr/bedrock.html
 */
export const AWS_BEDROCK_REGIONS = [
  // US
  "us-east-1",
  "us-east-2",
  "us-west-1",
  "us-west-2",
  // Africa
  "af-south-1",
  // Asia Pacific
  "ap-east-2",
  "ap-south-1",
  "ap-south-2",
  "ap-northeast-1",
  "ap-northeast-2",
  "ap-northeast-3",
  "ap-southeast-1",
  "ap-southeast-2",
  "ap-southeast-3",
  "ap-southeast-4",
  "ap-southeast-5",
  "ap-southeast-6",
  "ap-southeast-7",
  // Canada
  "ca-central-1",
  "ca-west-1",
  // Europe
  "eu-central-1",
  "eu-central-2",
  "eu-north-1",
  "eu-south-1",
  "eu-south-2",
  "eu-west-1",
  "eu-west-2",
  "eu-west-3",
  // Israel / Middle East
  "il-central-1",
  "me-central-1",
  "me-south-1",
  // Mexico / South America
  "mx-central-1",
  "sa-east-1",
] as const;

export type AWSBedrockRegion = (typeof AWS_BEDROCK_REGIONS)[number];
